import React from "react";
import classnames from "classnames";
import { formatPrice } from "../../../../utils";
import styles from "./Price.module.scss";
export var Price = function Price(a) {
  var b = a.number,
      c = a.promoted,
      d = a.className,
      e = formatPrice(b);
  return /*#__PURE__*/React.createElement("span", {
    className: classnames(d, styles.container)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.from
  }, "From"), /*#__PURE__*/React.createElement("span", {
    className: classnames(styles.number, "package--price-number")
  }, e, c ? "*" : ""));
};
export default Price;